/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as MfaRouteImport } from './routes/mfa'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as EnrollMfaRouteImport } from './routes/enroll-mfa'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedTranslationsRouteImport } from './routes/_authed/translations'
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings'
import { Route as AuthedPoliciesRouteImport } from './routes/_authed/policies'
import { Route as AuthedFeatureFlagsRouteImport } from './routes/_authed/feature-flags'
import { Route as AuthedDigestsRouteImport } from './routes/_authed/digests'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedAuditRouteImport } from './routes/_authed/audit'
import { Route as AuthedAnnouncementsRouteImport } from './routes/_authed/announcements'
import { Route as AuthedUsersIndexRouteImport } from './routes/_authed/users/index'
import { Route as AuthedCopyIndexRouteImport } from './routes/_authed/copy/index'
import { Route as AuthedUsersIdRouteImport } from './routes/_authed/users/$id'
import { Route as AuthedPhase2ShopTagsRouteImport } from './routes/_authed/phase2/shop-tags'
import { Route as AuthedPhase2PromptsRouteImport } from './routes/_authed/phase2/prompts'
import { Route as AuthedPhase2PillarsRouteImport } from './routes/_authed/phase2/pillars'
import { Route as AuthedPhase2MemberStoriesRouteImport } from './routes/_authed/phase2/member-stories'
import { Route as AuthedPhase2LaunchModeRouteImport } from './routes/_authed/phase2/launch-mode'
import { Route as AuthedPhase2CulturalMomentsRouteImport } from './routes/_authed/phase2/cultural-moments'
import { Route as AuthedPhase2CliniciansRouteImport } from './routes/_authed/phase2/clinicians'
import { Route as AuthedPhase2BrandsRouteImport } from './routes/_authed/phase2/brands'
import { Route as AuthedNewsletterSubscribersRouteImport } from './routes/_authed/newsletter/subscribers'
import { Route as AuthedNewsletterIssuesRouteImport } from './routes/_authed/newsletter/issues'
import { Route as AuthedModerationQueueRouteImport } from './routes/_authed/moderation/queue'
import { Route as AuthedCurationStoriesRouteImport } from './routes/_authed/curation/stories'
import { Route as AuthedCurationHomepageRouteImport } from './routes/_authed/curation/homepage'
import { Route as AuthedCopyBundlesRouteImport } from './routes/_authed/copy/bundles'
import { Route as AuthedCommunityGroupsRouteImport } from './routes/_authed/community/groups'
import { Route as AuthedCommunityEventsRouteImport } from './routes/_authed/community/events'
import { Route as AuthedCommunityChaptersRouteImport } from './routes/_authed/community/chapters'
import { Route as AuthedCommerceShippingRouteImport } from './routes/_authed/commerce/shipping'
import { Route as AuthedCommerceReviewsRouteImport } from './routes/_authed/commerce/reviews'
import { Route as AuthedCommerceReturnsRouteImport } from './routes/_authed/commerce/returns'
import { Route as AuthedCommercePayoutsRouteImport } from './routes/_authed/commerce/payouts'
import { Route as AuthedCommerceInventoryRouteImport } from './routes/_authed/commerce/inventory'
import { Route as AuthedCommerceDiscountCodesRouteImport } from './routes/_authed/commerce/discount-codes'
import { Route as AuthedCommerceDesignersRouteImport } from './routes/_authed/commerce/designers'
import { Route as AuthedPhase2WaitlistIndexRouteImport } from './routes/_authed/phase2/waitlist.index'
import { Route as AuthedCommerceProductsIndexRouteImport } from './routes/_authed/commerce/products.index'
import { Route as AuthedCommerceOrdersIndexRouteImport } from './routes/_authed/commerce/orders.index'
import { Route as AuthedPhase2WaitlistMetricsRouteImport } from './routes/_authed/phase2/waitlist.metrics'
import { Route as AuthedModerationAppealsIdRouteImport } from './routes/_authed/moderation/appeals.$id'
import { Route as AuthedCommerceProductsIdRouteImport } from './routes/_authed/commerce/products.$id'
import { Route as AuthedCommerceOrdersIdRouteImport } from './routes/_authed/commerce/orders.$id'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaRoute = MfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const EnrollMfaRoute = EnrollMfaRouteImport.update({
  id: '/enroll-mfa',
  path: '/enroll-mfa',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedTranslationsRoute = AuthedTranslationsRouteImport.update({
  id: '/translations',
  path: '/translations',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPoliciesRoute = AuthedPoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFeatureFlagsRoute = AuthedFeatureFlagsRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDigestsRoute = AuthedDigestsRouteImport.update({
  id: '/digests',
  path: '/digests',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAuditRoute = AuthedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnnouncementsRoute = AuthedAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUsersIndexRoute = AuthedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCopyIndexRoute = AuthedCopyIndexRouteImport.update({
  id: '/copy/',
  path: '/copy/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUsersIdRoute = AuthedUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPhase2ShopTagsRoute = AuthedPhase2ShopTagsRouteImport.update({
  id: '/phase2/shop-tags',
  path: '/phase2/shop-tags',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPhase2PromptsRoute = AuthedPhase2PromptsRouteImport.update({
  id: '/phase2/prompts',
  path: '/phase2/prompts',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPhase2PillarsRoute = AuthedPhase2PillarsRouteImport.update({
  id: '/phase2/pillars',
  path: '/phase2/pillars',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPhase2MemberStoriesRoute =
  AuthedPhase2MemberStoriesRouteImport.update({
    id: '/phase2/member-stories',
    path: '/phase2/member-stories',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedPhase2LaunchModeRoute = AuthedPhase2LaunchModeRouteImport.update({
  id: '/phase2/launch-mode',
  path: '/phase2/launch-mode',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPhase2CulturalMomentsRoute =
  AuthedPhase2CulturalMomentsRouteImport.update({
    id: '/phase2/cultural-moments',
    path: '/phase2/cultural-moments',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedPhase2CliniciansRoute = AuthedPhase2CliniciansRouteImport.update({
  id: '/phase2/clinicians',
  path: '/phase2/clinicians',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPhase2BrandsRoute = AuthedPhase2BrandsRouteImport.update({
  id: '/phase2/brands',
  path: '/phase2/brands',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedNewsletterSubscribersRoute =
  AuthedNewsletterSubscribersRouteImport.update({
    id: '/newsletter/subscribers',
    path: '/newsletter/subscribers',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedNewsletterIssuesRoute = AuthedNewsletterIssuesRouteImport.update({
  id: '/newsletter/issues',
  path: '/newsletter/issues',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedModerationQueueRoute = AuthedModerationQueueRouteImport.update({
  id: '/moderation/queue',
  path: '/moderation/queue',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCurationStoriesRoute = AuthedCurationStoriesRouteImport.update({
  id: '/curation/stories',
  path: '/curation/stories',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCurationHomepageRoute = AuthedCurationHomepageRouteImport.update({
  id: '/curation/homepage',
  path: '/curation/homepage',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCopyBundlesRoute = AuthedCopyBundlesRouteImport.update({
  id: '/copy/bundles',
  path: '/copy/bundles',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCommunityGroupsRoute = AuthedCommunityGroupsRouteImport.update({
  id: '/community/groups',
  path: '/community/groups',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCommunityEventsRoute = AuthedCommunityEventsRouteImport.update({
  id: '/community/events',
  path: '/community/events',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCommunityChaptersRoute = AuthedCommunityChaptersRouteImport.update({
  id: '/community/chapters',
  path: '/community/chapters',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCommerceShippingRoute = AuthedCommerceShippingRouteImport.update({
  id: '/commerce/shipping',
  path: '/commerce/shipping',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCommerceReviewsRoute = AuthedCommerceReviewsRouteImport.update({
  id: '/commerce/reviews',
  path: '/commerce/reviews',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCommerceReturnsRoute = AuthedCommerceReturnsRouteImport.update({
  id: '/commerce/returns',
  path: '/commerce/returns',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCommercePayoutsRoute = AuthedCommercePayoutsRouteImport.update({
  id: '/commerce/payouts',
  path: '/commerce/payouts',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCommerceInventoryRoute = AuthedCommerceInventoryRouteImport.update({
  id: '/commerce/inventory',
  path: '/commerce/inventory',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCommerceDiscountCodesRoute =
  AuthedCommerceDiscountCodesRouteImport.update({
    id: '/commerce/discount-codes',
    path: '/commerce/discount-codes',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedCommerceDesignersRoute = AuthedCommerceDesignersRouteImport.update({
  id: '/commerce/designers',
  path: '/commerce/designers',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPhase2WaitlistIndexRoute =
  AuthedPhase2WaitlistIndexRouteImport.update({
    id: '/phase2/waitlist/',
    path: '/phase2/waitlist/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedCommerceProductsIndexRoute =
  AuthedCommerceProductsIndexRouteImport.update({
    id: '/commerce/products/',
    path: '/commerce/products/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedCommerceOrdersIndexRoute =
  AuthedCommerceOrdersIndexRouteImport.update({
    id: '/commerce/orders/',
    path: '/commerce/orders/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedPhase2WaitlistMetricsRoute =
  AuthedPhase2WaitlistMetricsRouteImport.update({
    id: '/phase2/waitlist/metrics',
    path: '/phase2/waitlist/metrics',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedModerationAppealsIdRoute =
  AuthedModerationAppealsIdRouteImport.update({
    id: '/moderation/appeals/$id',
    path: '/moderation/appeals/$id',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedCommerceProductsIdRoute =
  AuthedCommerceProductsIdRouteImport.update({
    id: '/commerce/products/$id',
    path: '/commerce/products/$id',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedCommerceOrdersIdRoute = AuthedCommerceOrdersIdRouteImport.update({
  id: '/commerce/orders/$id',
  path: '/commerce/orders/$id',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/enroll-mfa': typeof EnrollMfaRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/mfa': typeof MfaRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email': typeof VerifyEmailRoute
  '/announcements': typeof AuthedAnnouncementsRoute
  '/audit': typeof AuthedAuditRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/digests': typeof AuthedDigestsRoute
  '/feature-flags': typeof AuthedFeatureFlagsRoute
  '/policies': typeof AuthedPoliciesRoute
  '/settings': typeof AuthedSettingsRoute
  '/translations': typeof AuthedTranslationsRoute
  '/commerce/designers': typeof AuthedCommerceDesignersRoute
  '/commerce/discount-codes': typeof AuthedCommerceDiscountCodesRoute
  '/commerce/inventory': typeof AuthedCommerceInventoryRoute
  '/commerce/payouts': typeof AuthedCommercePayoutsRoute
  '/commerce/returns': typeof AuthedCommerceReturnsRoute
  '/commerce/reviews': typeof AuthedCommerceReviewsRoute
  '/commerce/shipping': typeof AuthedCommerceShippingRoute
  '/community/chapters': typeof AuthedCommunityChaptersRoute
  '/community/events': typeof AuthedCommunityEventsRoute
  '/community/groups': typeof AuthedCommunityGroupsRoute
  '/copy/bundles': typeof AuthedCopyBundlesRoute
  '/curation/homepage': typeof AuthedCurationHomepageRoute
  '/curation/stories': typeof AuthedCurationStoriesRoute
  '/moderation/queue': typeof AuthedModerationQueueRoute
  '/newsletter/issues': typeof AuthedNewsletterIssuesRoute
  '/newsletter/subscribers': typeof AuthedNewsletterSubscribersRoute
  '/phase2/brands': typeof AuthedPhase2BrandsRoute
  '/phase2/clinicians': typeof AuthedPhase2CliniciansRoute
  '/phase2/cultural-moments': typeof AuthedPhase2CulturalMomentsRoute
  '/phase2/launch-mode': typeof AuthedPhase2LaunchModeRoute
  '/phase2/member-stories': typeof AuthedPhase2MemberStoriesRoute
  '/phase2/pillars': typeof AuthedPhase2PillarsRoute
  '/phase2/prompts': typeof AuthedPhase2PromptsRoute
  '/phase2/shop-tags': typeof AuthedPhase2ShopTagsRoute
  '/users/$id': typeof AuthedUsersIdRoute
  '/copy/': typeof AuthedCopyIndexRoute
  '/users/': typeof AuthedUsersIndexRoute
  '/commerce/orders/$id': typeof AuthedCommerceOrdersIdRoute
  '/commerce/products/$id': typeof AuthedCommerceProductsIdRoute
  '/moderation/appeals/$id': typeof AuthedModerationAppealsIdRoute
  '/phase2/waitlist/metrics': typeof AuthedPhase2WaitlistMetricsRoute
  '/commerce/orders/': typeof AuthedCommerceOrdersIndexRoute
  '/commerce/products/': typeof AuthedCommerceProductsIndexRoute
  '/phase2/waitlist/': typeof AuthedPhase2WaitlistIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/enroll-mfa': typeof EnrollMfaRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/mfa': typeof MfaRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email': typeof VerifyEmailRoute
  '/announcements': typeof AuthedAnnouncementsRoute
  '/audit': typeof AuthedAuditRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/digests': typeof AuthedDigestsRoute
  '/feature-flags': typeof AuthedFeatureFlagsRoute
  '/policies': typeof AuthedPoliciesRoute
  '/settings': typeof AuthedSettingsRoute
  '/translations': typeof AuthedTranslationsRoute
  '/commerce/designers': typeof AuthedCommerceDesignersRoute
  '/commerce/discount-codes': typeof AuthedCommerceDiscountCodesRoute
  '/commerce/inventory': typeof AuthedCommerceInventoryRoute
  '/commerce/payouts': typeof AuthedCommercePayoutsRoute
  '/commerce/returns': typeof AuthedCommerceReturnsRoute
  '/commerce/reviews': typeof AuthedCommerceReviewsRoute
  '/commerce/shipping': typeof AuthedCommerceShippingRoute
  '/community/chapters': typeof AuthedCommunityChaptersRoute
  '/community/events': typeof AuthedCommunityEventsRoute
  '/community/groups': typeof AuthedCommunityGroupsRoute
  '/copy/bundles': typeof AuthedCopyBundlesRoute
  '/curation/homepage': typeof AuthedCurationHomepageRoute
  '/curation/stories': typeof AuthedCurationStoriesRoute
  '/moderation/queue': typeof AuthedModerationQueueRoute
  '/newsletter/issues': typeof AuthedNewsletterIssuesRoute
  '/newsletter/subscribers': typeof AuthedNewsletterSubscribersRoute
  '/phase2/brands': typeof AuthedPhase2BrandsRoute
  '/phase2/clinicians': typeof AuthedPhase2CliniciansRoute
  '/phase2/cultural-moments': typeof AuthedPhase2CulturalMomentsRoute
  '/phase2/launch-mode': typeof AuthedPhase2LaunchModeRoute
  '/phase2/member-stories': typeof AuthedPhase2MemberStoriesRoute
  '/phase2/pillars': typeof AuthedPhase2PillarsRoute
  '/phase2/prompts': typeof AuthedPhase2PromptsRoute
  '/phase2/shop-tags': typeof AuthedPhase2ShopTagsRoute
  '/users/$id': typeof AuthedUsersIdRoute
  '/copy': typeof AuthedCopyIndexRoute
  '/users': typeof AuthedUsersIndexRoute
  '/commerce/orders/$id': typeof AuthedCommerceOrdersIdRoute
  '/commerce/products/$id': typeof AuthedCommerceProductsIdRoute
  '/moderation/appeals/$id': typeof AuthedModerationAppealsIdRoute
  '/phase2/waitlist/metrics': typeof AuthedPhase2WaitlistMetricsRoute
  '/commerce/orders': typeof AuthedCommerceOrdersIndexRoute
  '/commerce/products': typeof AuthedCommerceProductsIndexRoute
  '/phase2/waitlist': typeof AuthedPhase2WaitlistIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/enroll-mfa': typeof EnrollMfaRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/mfa': typeof MfaRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_authed/announcements': typeof AuthedAnnouncementsRoute
  '/_authed/audit': typeof AuthedAuditRoute
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/digests': typeof AuthedDigestsRoute
  '/_authed/feature-flags': typeof AuthedFeatureFlagsRoute
  '/_authed/policies': typeof AuthedPoliciesRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/translations': typeof AuthedTranslationsRoute
  '/_authed/commerce/designers': typeof AuthedCommerceDesignersRoute
  '/_authed/commerce/discount-codes': typeof AuthedCommerceDiscountCodesRoute
  '/_authed/commerce/inventory': typeof AuthedCommerceInventoryRoute
  '/_authed/commerce/payouts': typeof AuthedCommercePayoutsRoute
  '/_authed/commerce/returns': typeof AuthedCommerceReturnsRoute
  '/_authed/commerce/reviews': typeof AuthedCommerceReviewsRoute
  '/_authed/commerce/shipping': typeof AuthedCommerceShippingRoute
  '/_authed/community/chapters': typeof AuthedCommunityChaptersRoute
  '/_authed/community/events': typeof AuthedCommunityEventsRoute
  '/_authed/community/groups': typeof AuthedCommunityGroupsRoute
  '/_authed/copy/bundles': typeof AuthedCopyBundlesRoute
  '/_authed/curation/homepage': typeof AuthedCurationHomepageRoute
  '/_authed/curation/stories': typeof AuthedCurationStoriesRoute
  '/_authed/moderation/queue': typeof AuthedModerationQueueRoute
  '/_authed/newsletter/issues': typeof AuthedNewsletterIssuesRoute
  '/_authed/newsletter/subscribers': typeof AuthedNewsletterSubscribersRoute
  '/_authed/phase2/brands': typeof AuthedPhase2BrandsRoute
  '/_authed/phase2/clinicians': typeof AuthedPhase2CliniciansRoute
  '/_authed/phase2/cultural-moments': typeof AuthedPhase2CulturalMomentsRoute
  '/_authed/phase2/launch-mode': typeof AuthedPhase2LaunchModeRoute
  '/_authed/phase2/member-stories': typeof AuthedPhase2MemberStoriesRoute
  '/_authed/phase2/pillars': typeof AuthedPhase2PillarsRoute
  '/_authed/phase2/prompts': typeof AuthedPhase2PromptsRoute
  '/_authed/phase2/shop-tags': typeof AuthedPhase2ShopTagsRoute
  '/_authed/users/$id': typeof AuthedUsersIdRoute
  '/_authed/copy/': typeof AuthedCopyIndexRoute
  '/_authed/users/': typeof AuthedUsersIndexRoute
  '/_authed/commerce/orders/$id': typeof AuthedCommerceOrdersIdRoute
  '/_authed/commerce/products/$id': typeof AuthedCommerceProductsIdRoute
  '/_authed/moderation/appeals/$id': typeof AuthedModerationAppealsIdRoute
  '/_authed/phase2/waitlist/metrics': typeof AuthedPhase2WaitlistMetricsRoute
  '/_authed/commerce/orders/': typeof AuthedCommerceOrdersIndexRoute
  '/_authed/commerce/products/': typeof AuthedCommerceProductsIndexRoute
  '/_authed/phase2/waitlist/': typeof AuthedPhase2WaitlistIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/enroll-mfa'
    | '/forgot-password'
    | '/login'
    | '/mfa'
    | '/reset-password'
    | '/verify-email'
    | '/announcements'
    | '/audit'
    | '/dashboard'
    | '/digests'
    | '/feature-flags'
    | '/policies'
    | '/settings'
    | '/translations'
    | '/commerce/designers'
    | '/commerce/discount-codes'
    | '/commerce/inventory'
    | '/commerce/payouts'
    | '/commerce/returns'
    | '/commerce/reviews'
    | '/commerce/shipping'
    | '/community/chapters'
    | '/community/events'
    | '/community/groups'
    | '/copy/bundles'
    | '/curation/homepage'
    | '/curation/stories'
    | '/moderation/queue'
    | '/newsletter/issues'
    | '/newsletter/subscribers'
    | '/phase2/brands'
    | '/phase2/clinicians'
    | '/phase2/cultural-moments'
    | '/phase2/launch-mode'
    | '/phase2/member-stories'
    | '/phase2/pillars'
    | '/phase2/prompts'
    | '/phase2/shop-tags'
    | '/users/$id'
    | '/copy/'
    | '/users/'
    | '/commerce/orders/$id'
    | '/commerce/products/$id'
    | '/moderation/appeals/$id'
    | '/phase2/waitlist/metrics'
    | '/commerce/orders/'
    | '/commerce/products/'
    | '/phase2/waitlist/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/enroll-mfa'
    | '/forgot-password'
    | '/login'
    | '/mfa'
    | '/reset-password'
    | '/verify-email'
    | '/announcements'
    | '/audit'
    | '/dashboard'
    | '/digests'
    | '/feature-flags'
    | '/policies'
    | '/settings'
    | '/translations'
    | '/commerce/designers'
    | '/commerce/discount-codes'
    | '/commerce/inventory'
    | '/commerce/payouts'
    | '/commerce/returns'
    | '/commerce/reviews'
    | '/commerce/shipping'
    | '/community/chapters'
    | '/community/events'
    | '/community/groups'
    | '/copy/bundles'
    | '/curation/homepage'
    | '/curation/stories'
    | '/moderation/queue'
    | '/newsletter/issues'
    | '/newsletter/subscribers'
    | '/phase2/brands'
    | '/phase2/clinicians'
    | '/phase2/cultural-moments'
    | '/phase2/launch-mode'
    | '/phase2/member-stories'
    | '/phase2/pillars'
    | '/phase2/prompts'
    | '/phase2/shop-tags'
    | '/users/$id'
    | '/copy'
    | '/users'
    | '/commerce/orders/$id'
    | '/commerce/products/$id'
    | '/moderation/appeals/$id'
    | '/phase2/waitlist/metrics'
    | '/commerce/orders'
    | '/commerce/products'
    | '/phase2/waitlist'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/enroll-mfa'
    | '/forgot-password'
    | '/login'
    | '/mfa'
    | '/reset-password'
    | '/verify-email'
    | '/_authed/announcements'
    | '/_authed/audit'
    | '/_authed/dashboard'
    | '/_authed/digests'
    | '/_authed/feature-flags'
    | '/_authed/policies'
    | '/_authed/settings'
    | '/_authed/translations'
    | '/_authed/commerce/designers'
    | '/_authed/commerce/discount-codes'
    | '/_authed/commerce/inventory'
    | '/_authed/commerce/payouts'
    | '/_authed/commerce/returns'
    | '/_authed/commerce/reviews'
    | '/_authed/commerce/shipping'
    | '/_authed/community/chapters'
    | '/_authed/community/events'
    | '/_authed/community/groups'
    | '/_authed/copy/bundles'
    | '/_authed/curation/homepage'
    | '/_authed/curation/stories'
    | '/_authed/moderation/queue'
    | '/_authed/newsletter/issues'
    | '/_authed/newsletter/subscribers'
    | '/_authed/phase2/brands'
    | '/_authed/phase2/clinicians'
    | '/_authed/phase2/cultural-moments'
    | '/_authed/phase2/launch-mode'
    | '/_authed/phase2/member-stories'
    | '/_authed/phase2/pillars'
    | '/_authed/phase2/prompts'
    | '/_authed/phase2/shop-tags'
    | '/_authed/users/$id'
    | '/_authed/copy/'
    | '/_authed/users/'
    | '/_authed/commerce/orders/$id'
    | '/_authed/commerce/products/$id'
    | '/_authed/moderation/appeals/$id'
    | '/_authed/phase2/waitlist/metrics'
    | '/_authed/commerce/orders/'
    | '/_authed/commerce/products/'
    | '/_authed/phase2/waitlist/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  EnrollMfaRoute: typeof EnrollMfaRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  MfaRoute: typeof MfaRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa': {
      id: '/mfa'
      path: '/mfa'
      fullPath: '/mfa'
      preLoaderRoute: typeof MfaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/enroll-mfa': {
      id: '/enroll-mfa'
      path: '/enroll-mfa'
      fullPath: '/enroll-mfa'
      preLoaderRoute: typeof EnrollMfaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/translations': {
      id: '/_authed/translations'
      path: '/translations'
      fullPath: '/translations'
      preLoaderRoute: typeof AuthedTranslationsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/policies': {
      id: '/_authed/policies'
      path: '/policies'
      fullPath: '/policies'
      preLoaderRoute: typeof AuthedPoliciesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/feature-flags': {
      id: '/_authed/feature-flags'
      path: '/feature-flags'
      fullPath: '/feature-flags'
      preLoaderRoute: typeof AuthedFeatureFlagsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/digests': {
      id: '/_authed/digests'
      path: '/digests'
      fullPath: '/digests'
      preLoaderRoute: typeof AuthedDigestsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/audit': {
      id: '/_authed/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthedAuditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/announcements': {
      id: '/_authed/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof AuthedAnnouncementsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users/': {
      id: '/_authed/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthedUsersIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/copy/': {
      id: '/_authed/copy/'
      path: '/copy'
      fullPath: '/copy/'
      preLoaderRoute: typeof AuthedCopyIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users/$id': {
      id: '/_authed/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AuthedUsersIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/phase2/shop-tags': {
      id: '/_authed/phase2/shop-tags'
      path: '/phase2/shop-tags'
      fullPath: '/phase2/shop-tags'
      preLoaderRoute: typeof AuthedPhase2ShopTagsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/phase2/prompts': {
      id: '/_authed/phase2/prompts'
      path: '/phase2/prompts'
      fullPath: '/phase2/prompts'
      preLoaderRoute: typeof AuthedPhase2PromptsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/phase2/pillars': {
      id: '/_authed/phase2/pillars'
      path: '/phase2/pillars'
      fullPath: '/phase2/pillars'
      preLoaderRoute: typeof AuthedPhase2PillarsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/phase2/member-stories': {
      id: '/_authed/phase2/member-stories'
      path: '/phase2/member-stories'
      fullPath: '/phase2/member-stories'
      preLoaderRoute: typeof AuthedPhase2MemberStoriesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/phase2/launch-mode': {
      id: '/_authed/phase2/launch-mode'
      path: '/phase2/launch-mode'
      fullPath: '/phase2/launch-mode'
      preLoaderRoute: typeof AuthedPhase2LaunchModeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/phase2/cultural-moments': {
      id: '/_authed/phase2/cultural-moments'
      path: '/phase2/cultural-moments'
      fullPath: '/phase2/cultural-moments'
      preLoaderRoute: typeof AuthedPhase2CulturalMomentsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/phase2/clinicians': {
      id: '/_authed/phase2/clinicians'
      path: '/phase2/clinicians'
      fullPath: '/phase2/clinicians'
      preLoaderRoute: typeof AuthedPhase2CliniciansRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/phase2/brands': {
      id: '/_authed/phase2/brands'
      path: '/phase2/brands'
      fullPath: '/phase2/brands'
      preLoaderRoute: typeof AuthedPhase2BrandsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/newsletter/subscribers': {
      id: '/_authed/newsletter/subscribers'
      path: '/newsletter/subscribers'
      fullPath: '/newsletter/subscribers'
      preLoaderRoute: typeof AuthedNewsletterSubscribersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/newsletter/issues': {
      id: '/_authed/newsletter/issues'
      path: '/newsletter/issues'
      fullPath: '/newsletter/issues'
      preLoaderRoute: typeof AuthedNewsletterIssuesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/moderation/queue': {
      id: '/_authed/moderation/queue'
      path: '/moderation/queue'
      fullPath: '/moderation/queue'
      preLoaderRoute: typeof AuthedModerationQueueRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/curation/stories': {
      id: '/_authed/curation/stories'
      path: '/curation/stories'
      fullPath: '/curation/stories'
      preLoaderRoute: typeof AuthedCurationStoriesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/curation/homepage': {
      id: '/_authed/curation/homepage'
      path: '/curation/homepage'
      fullPath: '/curation/homepage'
      preLoaderRoute: typeof AuthedCurationHomepageRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/copy/bundles': {
      id: '/_authed/copy/bundles'
      path: '/copy/bundles'
      fullPath: '/copy/bundles'
      preLoaderRoute: typeof AuthedCopyBundlesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/community/groups': {
      id: '/_authed/community/groups'
      path: '/community/groups'
      fullPath: '/community/groups'
      preLoaderRoute: typeof AuthedCommunityGroupsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/community/events': {
      id: '/_authed/community/events'
      path: '/community/events'
      fullPath: '/community/events'
      preLoaderRoute: typeof AuthedCommunityEventsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/community/chapters': {
      id: '/_authed/community/chapters'
      path: '/community/chapters'
      fullPath: '/community/chapters'
      preLoaderRoute: typeof AuthedCommunityChaptersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/commerce/shipping': {
      id: '/_authed/commerce/shipping'
      path: '/commerce/shipping'
      fullPath: '/commerce/shipping'
      preLoaderRoute: typeof AuthedCommerceShippingRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/commerce/reviews': {
      id: '/_authed/commerce/reviews'
      path: '/commerce/reviews'
      fullPath: '/commerce/reviews'
      preLoaderRoute: typeof AuthedCommerceReviewsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/commerce/returns': {
      id: '/_authed/commerce/returns'
      path: '/commerce/returns'
      fullPath: '/commerce/returns'
      preLoaderRoute: typeof AuthedCommerceReturnsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/commerce/payouts': {
      id: '/_authed/commerce/payouts'
      path: '/commerce/payouts'
      fullPath: '/commerce/payouts'
      preLoaderRoute: typeof AuthedCommercePayoutsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/commerce/inventory': {
      id: '/_authed/commerce/inventory'
      path: '/commerce/inventory'
      fullPath: '/commerce/inventory'
      preLoaderRoute: typeof AuthedCommerceInventoryRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/commerce/discount-codes': {
      id: '/_authed/commerce/discount-codes'
      path: '/commerce/discount-codes'
      fullPath: '/commerce/discount-codes'
      preLoaderRoute: typeof AuthedCommerceDiscountCodesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/commerce/designers': {
      id: '/_authed/commerce/designers'
      path: '/commerce/designers'
      fullPath: '/commerce/designers'
      preLoaderRoute: typeof AuthedCommerceDesignersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/phase2/waitlist/': {
      id: '/_authed/phase2/waitlist/'
      path: '/phase2/waitlist'
      fullPath: '/phase2/waitlist/'
      preLoaderRoute: typeof AuthedPhase2WaitlistIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/commerce/products/': {
      id: '/_authed/commerce/products/'
      path: '/commerce/products'
      fullPath: '/commerce/products/'
      preLoaderRoute: typeof AuthedCommerceProductsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/commerce/orders/': {
      id: '/_authed/commerce/orders/'
      path: '/commerce/orders'
      fullPath: '/commerce/orders/'
      preLoaderRoute: typeof AuthedCommerceOrdersIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/phase2/waitlist/metrics': {
      id: '/_authed/phase2/waitlist/metrics'
      path: '/phase2/waitlist/metrics'
      fullPath: '/phase2/waitlist/metrics'
      preLoaderRoute: typeof AuthedPhase2WaitlistMetricsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/moderation/appeals/$id': {
      id: '/_authed/moderation/appeals/$id'
      path: '/moderation/appeals/$id'
      fullPath: '/moderation/appeals/$id'
      preLoaderRoute: typeof AuthedModerationAppealsIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/commerce/products/$id': {
      id: '/_authed/commerce/products/$id'
      path: '/commerce/products/$id'
      fullPath: '/commerce/products/$id'
      preLoaderRoute: typeof AuthedCommerceProductsIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/commerce/orders/$id': {
      id: '/_authed/commerce/orders/$id'
      path: '/commerce/orders/$id'
      fullPath: '/commerce/orders/$id'
      preLoaderRoute: typeof AuthedCommerceOrdersIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedAnnouncementsRoute: typeof AuthedAnnouncementsRoute
  AuthedAuditRoute: typeof AuthedAuditRoute
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedDigestsRoute: typeof AuthedDigestsRoute
  AuthedFeatureFlagsRoute: typeof AuthedFeatureFlagsRoute
  AuthedPoliciesRoute: typeof AuthedPoliciesRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedTranslationsRoute: typeof AuthedTranslationsRoute
  AuthedCommerceDesignersRoute: typeof AuthedCommerceDesignersRoute
  AuthedCommerceDiscountCodesRoute: typeof AuthedCommerceDiscountCodesRoute
  AuthedCommerceInventoryRoute: typeof AuthedCommerceInventoryRoute
  AuthedCommercePayoutsRoute: typeof AuthedCommercePayoutsRoute
  AuthedCommerceReturnsRoute: typeof AuthedCommerceReturnsRoute
  AuthedCommerceReviewsRoute: typeof AuthedCommerceReviewsRoute
  AuthedCommerceShippingRoute: typeof AuthedCommerceShippingRoute
  AuthedCommunityChaptersRoute: typeof AuthedCommunityChaptersRoute
  AuthedCommunityEventsRoute: typeof AuthedCommunityEventsRoute
  AuthedCommunityGroupsRoute: typeof AuthedCommunityGroupsRoute
  AuthedCopyBundlesRoute: typeof AuthedCopyBundlesRoute
  AuthedCurationHomepageRoute: typeof AuthedCurationHomepageRoute
  AuthedCurationStoriesRoute: typeof AuthedCurationStoriesRoute
  AuthedModerationQueueRoute: typeof AuthedModerationQueueRoute
  AuthedNewsletterIssuesRoute: typeof AuthedNewsletterIssuesRoute
  AuthedNewsletterSubscribersRoute: typeof AuthedNewsletterSubscribersRoute
  AuthedPhase2BrandsRoute: typeof AuthedPhase2BrandsRoute
  AuthedPhase2CliniciansRoute: typeof AuthedPhase2CliniciansRoute
  AuthedPhase2CulturalMomentsRoute: typeof AuthedPhase2CulturalMomentsRoute
  AuthedPhase2LaunchModeRoute: typeof AuthedPhase2LaunchModeRoute
  AuthedPhase2MemberStoriesRoute: typeof AuthedPhase2MemberStoriesRoute
  AuthedPhase2PillarsRoute: typeof AuthedPhase2PillarsRoute
  AuthedPhase2PromptsRoute: typeof AuthedPhase2PromptsRoute
  AuthedPhase2ShopTagsRoute: typeof AuthedPhase2ShopTagsRoute
  AuthedUsersIdRoute: typeof AuthedUsersIdRoute
  AuthedCopyIndexRoute: typeof AuthedCopyIndexRoute
  AuthedUsersIndexRoute: typeof AuthedUsersIndexRoute
  AuthedCommerceOrdersIdRoute: typeof AuthedCommerceOrdersIdRoute
  AuthedCommerceProductsIdRoute: typeof AuthedCommerceProductsIdRoute
  AuthedModerationAppealsIdRoute: typeof AuthedModerationAppealsIdRoute
  AuthedPhase2WaitlistMetricsRoute: typeof AuthedPhase2WaitlistMetricsRoute
  AuthedCommerceOrdersIndexRoute: typeof AuthedCommerceOrdersIndexRoute
  AuthedCommerceProductsIndexRoute: typeof AuthedCommerceProductsIndexRoute
  AuthedPhase2WaitlistIndexRoute: typeof AuthedPhase2WaitlistIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAnnouncementsRoute: AuthedAnnouncementsRoute,
  AuthedAuditRoute: AuthedAuditRoute,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedDigestsRoute: AuthedDigestsRoute,
  AuthedFeatureFlagsRoute: AuthedFeatureFlagsRoute,
  AuthedPoliciesRoute: AuthedPoliciesRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedTranslationsRoute: AuthedTranslationsRoute,
  AuthedCommerceDesignersRoute: AuthedCommerceDesignersRoute,
  AuthedCommerceDiscountCodesRoute: AuthedCommerceDiscountCodesRoute,
  AuthedCommerceInventoryRoute: AuthedCommerceInventoryRoute,
  AuthedCommercePayoutsRoute: AuthedCommercePayoutsRoute,
  AuthedCommerceReturnsRoute: AuthedCommerceReturnsRoute,
  AuthedCommerceReviewsRoute: AuthedCommerceReviewsRoute,
  AuthedCommerceShippingRoute: AuthedCommerceShippingRoute,
  AuthedCommunityChaptersRoute: AuthedCommunityChaptersRoute,
  AuthedCommunityEventsRoute: AuthedCommunityEventsRoute,
  AuthedCommunityGroupsRoute: AuthedCommunityGroupsRoute,
  AuthedCopyBundlesRoute: AuthedCopyBundlesRoute,
  AuthedCurationHomepageRoute: AuthedCurationHomepageRoute,
  AuthedCurationStoriesRoute: AuthedCurationStoriesRoute,
  AuthedModerationQueueRoute: AuthedModerationQueueRoute,
  AuthedNewsletterIssuesRoute: AuthedNewsletterIssuesRoute,
  AuthedNewsletterSubscribersRoute: AuthedNewsletterSubscribersRoute,
  AuthedPhase2BrandsRoute: AuthedPhase2BrandsRoute,
  AuthedPhase2CliniciansRoute: AuthedPhase2CliniciansRoute,
  AuthedPhase2CulturalMomentsRoute: AuthedPhase2CulturalMomentsRoute,
  AuthedPhase2LaunchModeRoute: AuthedPhase2LaunchModeRoute,
  AuthedPhase2MemberStoriesRoute: AuthedPhase2MemberStoriesRoute,
  AuthedPhase2PillarsRoute: AuthedPhase2PillarsRoute,
  AuthedPhase2PromptsRoute: AuthedPhase2PromptsRoute,
  AuthedPhase2ShopTagsRoute: AuthedPhase2ShopTagsRoute,
  AuthedUsersIdRoute: AuthedUsersIdRoute,
  AuthedCopyIndexRoute: AuthedCopyIndexRoute,
  AuthedUsersIndexRoute: AuthedUsersIndexRoute,
  AuthedCommerceOrdersIdRoute: AuthedCommerceOrdersIdRoute,
  AuthedCommerceProductsIdRoute: AuthedCommerceProductsIdRoute,
  AuthedModerationAppealsIdRoute: AuthedModerationAppealsIdRoute,
  AuthedPhase2WaitlistMetricsRoute: AuthedPhase2WaitlistMetricsRoute,
  AuthedCommerceOrdersIndexRoute: AuthedCommerceOrdersIndexRoute,
  AuthedCommerceProductsIndexRoute: AuthedCommerceProductsIndexRoute,
  AuthedPhase2WaitlistIndexRoute: AuthedPhase2WaitlistIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  EnrollMfaRoute: EnrollMfaRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  MfaRoute: MfaRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
